import { render } from "./NewDonorQuestionnaireMobilePage.vue?vue&type=template&id=4e4aa2c0"
import script from "./NewDonorQuestionnaireMobilePage.vue?vue&type=script&lang=js"
export * from "./NewDonorQuestionnaireMobilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__